import { Application } from "@hotwired/stimulus";
import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.css";
import { registerFormAssistObserver } from "../javascripts/cull-formassist";
import "./custom_turbo_actions";

const application = Application.start();

// application.debug = true
window.Stimulus = application;

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target, { frame: "_top", action: "advance" });
};

export { application };

document.addEventListener("turbo:load", () => {
  for (const el of document.querySelectorAll("[data-simplebar=init]")) {
    const bar = SimpleBar.instances.get(el);
    if (bar) {
      // スクロールバーが表示されるべき要素に表示されないことがある
      setTimeout(() => {
        bar.recalculate();
      }, 600);
    } else {
      // 戻った時にSimpleBarインスタンスが消える
      new SimpleBar(el, SimpleBar.helpers.getOptions(el));
    }
  }
});

registerFormAssistObserver();

// フォーム送信時、ボタンの無効化が解除されてから画面遷移するまでの僅かな間にボタンを押せる。
// そのため少し待ってから解除する。
Turbo.config.forms.submitter = {
  // デフォルトのまま
  beforeSubmit: (submitter) => (submitter.disabled = true),
  // しばらく待つ
  afterSubmit: (submitter) => {
    const dataTimeout = submitter.dataset.timeout;
    const seconds = dataTimeout != null ? Number(dataTimeout) : 1;
    setTimeout(() => {
      submitter.disabled = false;
    }, seconds * 1000);
  },
};

// chatbot
document.addEventListener("turbo:load", () => {
  if (window["ul_widget"] !== void 0 && document.getElementById("chatbot_script") != null) {
    // eslint-disable-next-line no-undef
    ul_widget("init", { id: "fe84ce041dccc14c8a3b", lg_id: "", mode_spa: true });
  }
});
